module.exports = __webpack_public_path__ + "static/img/img_awards_7en.9a441b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/img_awards_7en.png
// module id = HDYg
// module chunks = 15